import React, { useEffect, useState } from "react";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Paper,
  Snackbar,
  SnackbarContent,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router";
import Sidebar from "./components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import OfflineBoltIcon from "@mui/icons-material/OfflineBolt";
import moment from "moment/moment";
import {
  setfrontview,
  setleftview,
  setrightview,
  settopview,
} from "./Reducers/reducer";
import MainLoader from "./components/MainLoader";
import imgurl from "./assests/images/imgurl";
import noDataFound from "../src/assests/images/no-report-ic.svg";
import inProcessIcon from "../src/assests/images/no-report-ic.gif";
import AlertComp from "./Alert";
import i18next from "i18next";
import SyncIcon from '@mui/icons-material/Sync';
import { clearImagesInRedux, downloadPDF, gTagTracking, serviceDown, trackEvent } from "./utils/UtilityFunctions";
import { postApi } from "./api/services";

function Reports() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setAlertMsg] = useState("");
  const [reportList, setReportList] = useState([]);
  const [noData, setNoData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRotating, setIsRotating] = useState(false);
  const [inProcess, setInProcess] = useState(false);
  const [gender, setGender] = useState('')
  const [showEuCTA, setShowEuCTA] = useState('')
  const vertical = "bottom";
  const horizontal = "right";

  let { Topview, Backview, Leftview, Rightview, Frontview, Gender } = useSelector(
    (state) => state.user.profile
  );

  const locale = useSelector((state) => state.language.langData)

  const reports = [
    {
      id: "RPT-004",
      createdOn: moment().format().split("T")[0],
      status: "Generating",
    },
    { id: "RPT-003", createdOn: "2025-03-31", status: "Generated" },
    { id: "RPT-002", createdOn: "2025-03-31", status: "Generated" },
    { id: "RPT-001", createdOn: "2025-03-31", status: "Generated" },
    // { id: "RPT-003", createdOn: "2025-04-01" },
  ];

  const validate = [
    { id: "RPT-001", createdOn: "2025-03-30" },
    { id: "RPT-002", createdOn: "2025-03-31" },
    // { id: "RPT-003", createdOn: "2025-04-01" },
  ];

  const checkReport = () => {
    navigate("/report");
  };

  useEffect(() => {
    getReportList();
    let genderVal
    if(Gender == ''){
      genderVal = localStorage.getItem('gender')
    } else {
      genderVal = Gender
    }
    setGender(genderVal)
    if (
      Frontview &&
      Topview &&
      Leftview &&
      Rightview &&
      location?.state?.from == "previewTest" &&
      genderVal.toUpperCase() == "MALE"
    ) {
      sendReport('male');
    } else if( Frontview && Topview && location?.state?.from == "previewTest" && genderVal.toUpperCase() == "FEMALE"){
      sendReport('female')
    }
    setShowEuCTA(JSON.parse(localStorage.getItem("show_eu_cta") || false))
  }, []);

  // const sendReport = async (genderVal) => {
  //   setInProcess(true)
  //   try {
  //     let imgObj = genderVal.toUpperCase() == "MALE" ?
  //       {
  //         front_img: Frontview,
  //         top_img: Topview,
  //         left_img: Leftview,
  //         right_img: Rightview,
  //       } : 
  //       {
  //         front_img: Frontview,
  //         top_img: Topview,
  //       }
  //     setalertopen(true);
  //     setAlertMsg("processing");
  //     // setIsLoading(true)
  //     let apiobj = {
  //       image_data: imgObj,
  //       userid:
  //         localStorage.getItem("user_id") && localStorage.getItem("user_id"),
  //       channel: window.cordova ? "mobile" : "webapp",
  //       website_source : "alopexia"
  //     };
  //     console.log("predict_all params", apiobj);
  //     const data = await postApi('predict_all', apiobj)
  //     console.log("predict_all data", data);
  //     location.state.from = "";
  //     if (Object.keys(data).length > 0) {
  //       if(data.error){
  //         serviceDown(navigate, '/taketest')
  //         await trackEvent('test_submitted', 'fail', data.error, localStorage.getItem('phno'))
  //         await gTagTracking('test_submitted', {
  //           action: 'fail',
  //           error: data.error,
  //           mobile_number: localStorage.getItem('phno')
  //         })
  //         setalertopen(false);
  //         setAlertMsg("error");
  //         setIsLoading(false)
  //       } else {
  //         // setIsLoading(false)
  //         await trackEvent('test_submitted', 'success', '', localStorage.getItem('phno'))
  //         await gTagTracking('test_submitted', {
  //           action: 'success',
  //           error: '',
  //           mobile_number: localStorage.getItem('phno')
  //         })
  //         clearImagesInRedux(dispatch)
  //         setNoData(false);
  //         setalertopen(false);
  //         setAlertMsg("completed");
  //         getReportList('quickreport', 'inprocess');
  //       }
  //     } else {
  //       setNoData(true);
  //     }
  //   } catch (err) {
  //     console.log("err", err);
  //     serviceDown(navigate, '/taketest')
  //     await trackEvent('test_submitted', 'fail', err, localStorage.getItem('phno'))
  //     await gTagTracking('test_submitted', {
  //       action: 'fail',
  //       error: err,
  //       mobile_number: localStorage.getItem('phno')
  //     })
  //     setalertopen(false);
  //     setAlertMsg("error");
  //     setIsLoading(false)
  //   }
  // };

  const getReportList = async (received, inprocess) => {
    const userObj = JSON.parse(localStorage.getItem('user_obj'))
    try {
      setIsLoading(true);
      let apiobj = {
        user_id: userObj.user_id,
      };
      console.log("get_hair_analysis_status params", apiobj);
      const data = await postApi('get_hair_analysis_status', apiobj)
      if (data?.length > 0) {
        console.log("get_hair_analysis_status res", data);
        if(received){
          await trackEvent('quick_report_received', 'success', '', localStorage.getItem('phno'), userObj.user_id)
          await gTagTracking('quick_report_received', {
            action: 'success',
            error: '',
            mobile_number: localStorage.getItem('phno'),
            user_id: userObj.user_id
          })
        } else {
          await trackEvent('report_history_viewed', 'success', '', localStorage.getItem('phno'), userObj.user_id)
          await gTagTracking('report_history_viewed', {
            action: 'success',
            error: '',
            mobile_number: localStorage.getItem('phno'),
            user_id: userObj.user_id
          })
        }     
        setReportList(data);
        setNoData(false);
        setIsLoading(false);
        setIsRotating(false);
        setInProcess(false);
      } else {
        setIsLoading(false);
        setIsRotating(false);
        setNoData(true);
      }
    } catch (err) {
      console.log("err", err);
      if(received) {
        await trackEvent('quick_report_received', 'fail', err, localStorage.getItem('phno'), userObj.user_id)
        await gTagTracking('quick_report_received', {
          action: 'fail',
          error: err,
          mobile_number: localStorage.getItem('phno'),
          user_id: userObj.user_id
        })
      } else {
        await trackEvent('report_history_viewed', 'fail', err, localStorage.getItem('phno'), userObj.user_id)
        await gTagTracking('report_history_viewed', {
          action: 'fail',
          error: err,
          mobile_number: localStorage.getItem('phno'),
          user_id: userObj.user_id
        })
      }
      setIsLoading(false)
      serviceDown()
    }
  };

  const getReportDetails = async (id) => {
    try {
      setIsLoading(true);
      let apiobj = {
        analysis_id: id,
      };
      console.log("get_hair_analysis_report params", apiobj);
      const data = await postApi('get_hair_analysis_report', apiobj)
      if (data) {
        console.log("get_hair_analysis_report res", data);
        setIsLoading(false);
        swal({
          title: `${i18next.t("Report is invalid")}`,
          text: `${i18next.t("Reason")} : ${data?.report?.final_comments}`,
        });
      }
    } catch (err) {
      console.log("err", err);
      setIsLoading(false)
      serviceDown()
    }
  };

  const goToReport = (report) => {
    console.log("goToReport", report);
    if(report.current_stage === "AI_GENERATED"){
      // getAiReportDetails(report.analysis_id)
      navigate("/report", { state: { analysis_id: report.analysis_id, current_stage: report.current_stage} });
    } else {
      if (report.status == "Completed") {
        // localStorage.setItem('report_analysis_id', JSON.stringify(report.analysis_id))
        navigate("/report", { state: { analysis_id: report.analysis_id, current_stage: report.current_stage } });
      } else if (report.status === "Rejected") {
        getReportDetails(report.analysis_id);
      } else {
        swal({
          title: `Your report is ${report.status.toLowerCase()}`,
        });
      }
    }
  };

  // beta user feedback
  const proceedToNxt = () => {
    let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
      let url = `https://aloxa.ai/feedback?phno=${encrypted}&lang=${locale}`;
      console.log('urlllll', url)
      window.open(url, "_blank");
  };

  const encryptPhoneNum = (phone) => {
    return btoa(encodeURIComponent(phone))
  }

  const handleRotate = () => {
    setIsRotating(true);  
    getReportList();
  };

  const handleDownload = (e, report) => {
    e.stopPropagation();
    setIsLoading(true)
    let params = {
      report_id: report.report_id,
      language: locale
    }
    postApi("generate-report", params)
      .then((res) => {
        console.log("generate-report res", res);
        if(res?.pdf_data){
          downloadPDF(res?.pdf_data, report.report_id, locale.toUpperCase())
        }
      })
      .catch((err) => {
        console.log("err");  
        setIsLoading(false)
        serviceDown()
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const handleExplore = async (e, report) => {
    let userObj = JSON.parse(localStorage.getItem('user_obj'))
    try {
      e.stopPropagation()
      if(
        report?.norwoodstage == 0 || 
        report?.norwoodstage == 4 || 
        // report?.norwoodstage == 7 || 
        !showEuCTA ||
        ["AI_GENERATED", "VALIDATOR_1_ASSIGNED", "VALIDATOR_1_COMPLETED"].includes(report?.current_stage) 
      ){
        return
      } else {
        // await trackEvent('explored_treatment', 'success', "", localStorage.getItem('phno'))
        // await gTagTracking('explored_treatment', {
        //   action: 'success',
        //   error: '',
        //   mobile_number: localStorage.getItem('phno')
        // })
        // let encrypted = encryptPhoneNum(localStorage.getItem('phno'))
        // let url = `https://shop.alopexia.com/products/alopexia-hair-restoration-medicine?phone=${encrypted}`;
        // window.open(url, "_self");
        if(userObj.medical_history_present){
          navigate('/prescriptions')
        } else {
          navigate('/healthdeclaration')
        }
      }
    } catch (err) {
      console.log("err", err);
      // await trackEvent('explored_treatment', 'fail', err, localStorage.getItem('phno'), userObj.user_id)
      // await gTagTracking('explored_treatment', {
      //   action: 'fail',
      //   error: err,
      //   mobile_number: localStorage.getItem('phno'),
      //   user_id: userObj.user_id
      // })
    }
  }

  return (
    <>
      {isLoading && <MainLoader />}
      <div className="photo-container main-section-container assessmentReportSection">
        <Grid
          container
          spacing={0}
          className="d-flex justify-content-start align-items-center header"
        >
          {/* <Grid item xs={1} className="">
            <div className="d-flex justify-content-start align-items-center">
              <span
                className="backButtonDiv"
                onClick={() => navigate("/taketest")}
              >
                <ArrowBackOutlinedIcon className="arrowBackBtn"></ArrowBackOutlinedIcon>
              </span>
            </div>
          </Grid> */}
          <Grid
            item
            xs={10}
            className="d-flex justify-content-center align-items-center reportPageHead"
          >
            <Typography variant="h6" className="title ml-0px">
              {i18next.t("Report History")}
            </Typography>
          </Grid>
          <Grid item xs={1} onClick={handleRotate} className="cursor-pointer">
            <SyncIcon className={isRotating ? "rotate-once" : ""} />
          </Grid>
          <Grid item xs={1}>
            <Sidebar />
          </Grid>
        </Grid>
        {/* <div className="d-flex justify-content-end align-items-center mt-20px">
          <Button
            variant="contained"
            className="betaUserFeedbackLink"
            onClick={() => proceedToNxt()}
          >
            {i18next.t("Beta Test Feedback")}
          </Button>
        </div> */}
        
        {
          !noData ? 
            <div className="reportcardscontainer">
              {
                reportList.map((report) => {
                  return(
                    <div 
                      className="reportCard cursor-pointer"
                      key={report.analysis_id}
                      onClick={() => goToReport(report)}
                    >
                      <Grid container spacing={2} className="reportCardMain">
                        <Grid item xs={2} className="iconContainer">
                          <img src={imgurl.reportIcon} className="reportIcon"/>
                        </Grid>
                        <Grid item xs={7} className="repInfo">
                          <p className="mb-0 reportId">{`${i18next.t("Report ID")}: ${report.report_id}`}</p>
                          <p className="mb-0 reportDate">{`${i18next.t("Created On")}: ${moment(report.analysis_time).format("LL")}`}</p>
                        </Grid>
                        {
                          report.current_stage === "VALIDATOR_2_COMPLETED" && report.status != "Rejected" ? 
                          (
                            <Grid item xs={3} className="statusReportDiv completed">
                              <CheckCircleIcon />
                              <Typography className="completedTxt">
                                {i18next.t("Report")}
                              </Typography>
                            </Grid>
                          ) : (report.current_stage === "AI_GENERATED" || report.current_stage === "VALIDATOR_1_COMPLETED" || report.current_stage === "VALIDATOR_2_ASSIGNED") && report.status != "Rejected" ? 
                          (
                            <Grid item xs={3} className="statusReportDiv quickreport">
                              <OfflineBoltIcon />
                              <Typography className="quickreportTxt">
                                {}
                                {i18next.t("Report")}
                              </Typography>
                            </Grid>
                          ) : (report.current_stage === "AI_GENERATED" || report.current_stage === "VALIDATOR_1_ASSIGNED") && report.status != "Rejected" ? 
                          (
                            <Grid item xs={3} className="statusReportDiv generating">
                              <ThreeDots
                                visible={true}
                                height="20"
                                width="25"
                                color="red"
                                radius="9"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                              />
                              <Typography className="generatingDiv">
                                {report.status === "Completed"
                                  ? i18next.t("Report")
                                  : "In Progress"}
                              </Typography>
                            </Grid>
                          ) : report.status === "Rejected" ? 
                          (
                            <Grid item xs={3} className="statusReportDiv rejectDiv">
                              <CancelIcon />
                              <Typography className="rejectTxt">
                                {i18next.t("Invalid")}
                              </Typography>
                            </Grid>
                          ) : (
                            ""
                          )
                        }
                      </Grid>
                      {
                        report.status != "Rejected" ? 
                          <div className='reportSubCardMain'>
                            {/* <p className='reportSubInfo reportStage'>
                              {
                                report.norwoodstage === 0 ?
                                  i18next.t("No recession")
                                    :
                                  `${i18next.t("Grade")} ${report.norwoodstage}`
                              }
                            </p> */}
                            <p className={((report?.norwoodstage == 0 || report?.norwoodstage == 4) || (report.current_stage === "AI_GENERATED" || report.current_stage === "VALIDATOR_1_ASSIGNED" || report.current_stage === "VALIDATOR_1_COMPLETED")) ? 'reportSubInfo reportStage explore disabled' : 'reportSubInfo reportStage explore'} onClick={(e) => handleExplore(e, report)}>
                              {i18next.t(
                                locale === 'en' ?
                                  "Access Prescription - Only Treatment" :
                                locale === 'fr' ?
                                  "Accéder au traitement sur prescription médicale " :
                                locale === 'es' ?
                                  "Acceder al tratamiento con prescripción médica " :
                                "Access Prescription - Only Treatment"
                              )}
                            </p>
                          </div>
                            :
                          <div className='reportSubCardMain invalid'>
                            <p className='reportSubInfo reportStage'>{`${i18next.t("Reason")}: ${report.reason}`}</p>
                          </div>
                      }
                    </div>
                  )
                })
              }
            </div>
              : 
          inProcess ?
            <div className="nodatadiv">
              <div className="nodatafoundimg">
                <img src={inProcessIcon} />
              </div>
              <Typography className="">
                {i18next.t("Just a moment, your report is on the way.")}
              </Typography>
            </div> 
              :
            <div className="nodatadiv">
              <div className="nodatafoundimg">
                <img src={noDataFound} />
              </div>
              <Typography className="">
                {i18next.t("No reports found.")}
              </Typography>
            </div>
        }
      </div>
      <AlertComp open={alertopen} msg={alertmsg} page={"report"} />
    </>
  );
}

export default Reports;
